import { useIsAuthenticated, useAccount } from '@azure/msal-react';
import { useEffect } from 'react';
import appInsights from '../analytics/app-insights';

const useSetupAppInsights = () => {
    const isAuthenticated = useIsAuthenticated();
    const account = useAccount();

    useEffect(() => {
        if (isAuthenticated && account) {
            appInsights.setAuthenticatedUserContext(account.username, account.localAccountId);
        }

        return () => {
            appInsights.clearAuthenticatedUserContext();
        };
    }, [isAuthenticated, account]);
};

export default useSetupAppInsights;
